import BooksImg1 from "../../assets/images/BooksImg1.png";
import BooksImg2 from "../../assets/images/BooksImg2.png";
import BooksImg3 from "../../assets/images/BooksImg3.png";
import BooksImg4 from "../../assets/images/BooksImg4.png";
import PartnerIcon1 from "../../assets/images/partnerIcon1.svg";
import PartnerIcon2 from "../../assets/images/partnerIcon2.svg";
import PartnerIcon3 from "../../assets/images/partnerIcon3.png";
import ConfrenceIcon1 from "../../assets/images/confrenceIcon1.svg";
import ConfrenceIcon2 from "../../assets/images/confrenceIcon2.svg";
import ConfrenceIcon3 from "../../assets/images/confrenceIcon3.svg";
import styles from "./Publications.module.css";

export const partnersData = [
  {
    id: 1,
    imageClass: styles.image1,
    img: PartnerIcon1,
    alt: "IMPARC Research Journal",
    title: "IMPARC Research Journal",
    description:
      "Flagship journal publishing high-impact research across multiple disciplines",
    tags: ["Impact Factor: 3.2", "Open Access"],
    time: "Quarterly Publication",
    review: "Peer Review: 4-6 weeks",
    buttonText: "Submit Paper",
  },
  {
    id: 2,
    imageClass: styles.image2,
    img: PartnerIcon2,
    alt: "Sustainability & Innovation",
    title: "Sustainability & Innovation",
    description:
      "Specialized journal focusing on sustainable technologies and environmental research",
    tags: ["Impact Factor: 2.8", "Indexed"],
    time: "Bi-monthly Publication",
    review: "Peer Review: 3-5 weeks",
    buttonText: "Submit Paper",
  },
  {
    id: 3,
    imageClass: styles.image3,
    img: PartnerIcon3,
    alt: "AI & Technology Ethics",
    title: "AI & Technology Ethics",
    description:
      "Partner journal exploring ethical implications of emerging technologies",
    tags: ["Impact Factor: 4.1", "Partner Journal"],
    time: "Monthly Publication",
    review: "Peer Review: 2-4 weeks",
    buttonText: "Submit Paper",
  },
];

export const cardData = [
  {
    id: 1,
    img: BooksImg1,
    title: "Advanced AI Research Method",
    description: "Comprehensive guide to modern AI research methodologies",
    tag: "2024 Edition",
    pages: "456 pages",
  },
  {
    id: 2,
    img: BooksImg2,
    title: "Sustainable Technology Handbook",
    description: "Edited volume on sustainable innovation practices",
    tag: "Edited Volume",
    pages: "623 pages",
  },
  {
    id: 3,
    img: BooksImg3,
    title: "Research Excellence Framework",
    description: "Guidelines for conducting high-impact research",
    tag: "Handbook",
    pages: "298 pages",
  },
  {
    id: 4,
    img: BooksImg4,
    title: "Collaborative Research Models",
    description: "Best practices in multi-institutional research",
    tag: "Multi-Author",
    pages: "387 pages",
  },
];

export const ConferenceData = [
  {
    id: 1,
    imageClass: styles.image1,
    img: ConfrenceIcon1,
    alt: "IMPARC Annual Conference 2024",
    title: "IMPARC Annual Conference 2024",
    description:
      "Comprehensive proceedings from our flagship annual research conference",
    tags: ["2024"],
    papers: "156 research papers",
    represented: "45 countries represented",
    download: "2,340 downloads",
    buttonText: "Download Proceedings",
  },
  {
    id: 2,
    imageClass: styles.image2,
    img: ConfrenceIcon2,
    alt: "Innovation & Sustainability Summit",
    title: "Innovation & Sustainability Summit",
    description:
      "Proceedings from the international sustainability research summit",
    tags: ["2023"],
    papers: "89 research papers",
    represented: "32 countries represented",
    download: "1876 downloads",
    buttonText: "Download Proceedings",
  },
  {
    id: 3,
    imageClass: styles.image3,
    img: ConfrenceIcon3,
    alt: "AI Ethics & Society Conference",
    title: "AI Ethics & Society Conference",
    description:
      "Proceedings exploring ethical dimensions of artificial intelligence",
    tags: ["2023"],
    papers: "67 research papers",
    represented: "28 countries represented",
    download: "1532 downloads",
    buttonText: "Download Proceedings",
  },
];

export const DOIPapersData = [
  {
    id: 1,
    title: "Machine Learning Applications in Sustainable Energy Systems",
    description:
      "Comprehensive analysis of ML algorithms for optimizing renewable energy distribution networks",
    tags: ["AI & Machine Learning", "Sustainability", "Energy Systems"],
    doctorName: "Dr. Sarah Chen, Prof. Michael Rodriguez",
    views: "1,234 views",
    DOI: "10. 1234 /imparc. 2024.001",
    time: "Monthly Publication",
    buttonText: "View Paper",
  },
  {
    id: 1,
    title: "Machine Learning Applications in Sustainable Energy Systems",
    description:
      "Comprehensive analysis of ML algorithms for optimizing renewable energy distribution networks",
    tags: ["AI & Machine Learning", "Sustainability", "Energy Systems"],
    doctorName: "Dr. Sarah Chen, Prof. Michael Rodriguez",
    views: "1,234 views",
    DOI: "10. 1234 /imparc. 2024.001",
    time: "Monthly Publication",
    buttonText: "View Paper",
  },
  {
    id: 1,
    title: "Machine Learning Applications in Sustainable Energy Systems",
    description:
      "Comprehensive analysis of ML algorithms for optimizing renewable energy distribution networks",
    tags: ["AI & Machine Learning", "Sustainability", "Energy Systems"],
    doctorName: "Dr. Sarah Chen, Prof. Michael Rodriguez",
    views: "1,234 views",
    DOI: "10. 1234 /imparc. 2024.001",
    time: "Monthly Publication",
    buttonText: "View Paper",
  },
];
